import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "@chakra-ui/icon";
import React from "react";
const NotMatchedIcon = props => (_jsx(Icon, Object.assign({ viewBox: "0 0 16 16", fill: "none", height: "16px", width: "16px" }, props, { children: _jsx("rect", { x: "1", y: "1", width: "14", height: "14", rx: "7", stroke: "#D69E2E", "stroke-width": "2" }) })));
export default NotMatchedIcon;
